<template>
  <v-container class="mt-0">
    <div class="field-group-header">Page Size (optional)</div>

    <v-row>
      <v-col cols="6">
        <validation-provider
          :vid="uuid()"
          name="X"
          rules="pageSizeXRequired"
          v-slot="v"
        >
          <v-text-field
            label="X"
            v-model.number="graphics.pageSize.x"
            @input="updateGraphics"
          ></v-text-field>
          <span class="validation-message">{{ v.errors[0] }}</span>
        </validation-provider>
      </v-col>

      <v-col cols="6">
        <validation-provider
          :vid="uuid()"
          name="Y"
          rules="pageSizeYRequired"
          v-slot="v"
        >
          <v-text-field
            label="Y"
            v-model.number="graphics.pageSize.y"
            @input="updateGraphics"
          ></v-text-field>
          <span class="validation-message">{{ v.errors[0] }}</span>
        </validation-provider>
      </v-col>
    </v-row>

    <div class="field-group-header mt-5">Grid Resolution</div>
    <v-tabs v-model="tab">
      <v-tab key="fbd">FBD</v-tab>
      <v-tab key="ld">LD</v-tab>
      <v-tab key="sfc">SFC</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <scaling
          :scaling="graphics.fbd"
          @update="updateFbdScaling"
        />
      </v-tab-item>
      <v-tab-item>
        <scaling
          :scaling="graphics.ld"
          @update="updateLdScaling"
        />
      </v-tab-item>
      <v-tab-item>
        <scaling
          :scaling="graphics.sfc"
          @update="updateSfcScaling"
        />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import { ValidationProvider, extend } from "vee-validate";
import { required_if } from "vee-validate/dist/rules";
import { isFinite } from "lodash";
import uuid from "src/mixins/uuid";
import Scaling from "./Scaling";

export default {
  name: "Graphics",
  components: { ValidationProvider, Scaling },
  mixins: [uuid],
  data() {
    return {
      tab: 0,
    };
  },
  computed: {
    graphics() {
      return this.$store.state.projectProperties.graphics;
    },
  },
  methods: {
    updateGraphics() {
      this.$store.dispatch("updateProjectProperties", {
        graphics: this.graphics,
      });
    },
    updateFbdScaling(scaling) {
      this.graphics.fbd = scaling;
      this.updateGraphics();
    },
    updateLdScaling(scaling) {
      this.graphics.ld = scaling;
      this.updateGraphics();
    },
    updateSfcScaling(scaling) {
      this.graphics.sfc = scaling;
      this.updateGraphics();
    },
  },
  mounted() {
    extend("pageSizeXRequired", {
      ...required_if,
      validate: (value) => {
        if (!isFinite(this.graphics.pageSize.x)) {
          return true;
        }

        if (isFinite(value)) {
          return true;
        }

        return "Page Size X is required if Page Size Y is provided";
      },
    });
    extend("pageSizeYRequired", {
      ...required_if,
      validate: (value) => {
        if (!isFinite(this.graphics.pageSize.y)) {
          return true;
        }

        if (isFinite(value)) {
          return true;
        }

        return "Page Size Y is required if Page Size X is provided";
      },
    });
  },
};
</script>
